import { SagaIterator } from 'redux-saga';
import { getProjectDetails } from 'src/modules/project-view/selectors/getProjectDetails';
import { REPORT_FETCH } from 'src/modules/report/actions/ReportActions';
import { loadReportData } from 'src/modules/report/sagas/utils/loadReportData';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { call, put, select } from 'typed-redux-saga';

export function* fetchReportData(): SagaIterator<void> {
  try {
    yield* call(logDebug, 'Fetching report data...');

    const project = yield* select(getProjectDetails);
    const report = yield* call(loadReportData, project);

    yield* put(REPORT_FETCH.trigger(report));
    yield* call(logDebug, 'Fetching report data... done', report);
  } catch (error) {
    yield* call(logError, 'Fetching report data... error', error);
    throw error;
  }
}
